'use strict';

import ReconnectingWebSocket from 'reconnecting-websocket';

import { EVENT_QUOTES } from '@/utils/event-bus';
import { codec, packetQuotesSubscribe, packetQuotesUnsubscribe, packetQuotesNew } from '@/utils/protobuf';

let socket = null;
function convertQuote (quote) {
    const precision = (quote.Flags & 0x0f);
    return {
        s: quote.Symbol,
        r: Number(quote.Rate * Math.pow(10, -precision)).toFixed(precision),
        sp: Number(quote.Spread * Math.pow(10, -precision)).toFixed(precision),
        dt: new Date(quote.Time * 1000),
        n: quote.Number,
        iw: (quote.Flags & 0x10) > 0,
        om: (quote.Flags & 0x20) > 0
    };
};

function sendPacket (type, id, data) {
    const buf = codec.encode({type, id, data});
    socket.send(buf);
};

export default class WsGate {
    constructor (url, eventBus) {
        this.url = url;
        this.eventBus = eventBus;
        this.packetId = 0;
    }

    open () {
        // Async
        let self = this;
        return new Promise((resolve, reject) => {
            socket = new ReconnectingWebSocket(self.url, [], {connectionTimeout: 10000});
            socket.binaryType = 'arraybuffer';
            socket.onopen = function () {
                socket.binaryType = 'arraybuffer';
                resolve({
                    subscribe: (symbols) => {
                        sendPacket(packetQuotesSubscribe, self.packetId++, {Symbols: symbols});
                    },
                    unsubscribe: (symbols) => {
                        sendPacket(packetQuotesUnsubscribe, self.packetId++, {Symbols: symbols});
                    }
                });
            };

            socket.onmessage = function (event) {
                if (typeof event.data !== 'string') {
                    const packet = codec.decode(event.data);
                    if (packet.type === packetQuotesNew) {
                        let quote;
                        for (let i = 0; i < packet.message.QuotesTrade.length; i++) {
                            quote = convertQuote(packet.message.QuotesTrade[i]);
                            self.eventBus.send(EVENT_QUOTES, quote);
                        }
                    }
                }
            };
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/wsgate.js